export function setCspContent () {
    const csp = {
        'default-src': [ "'self'" ],

        'img-src': [
            "'self'",
            'data:',
            'https://s3.eu-west-2.amazonaws.com/' + process.env.REACT_APP_AWS_BUCKET + '/',
            'https://s3.eu-west-2.amazonaws.com/orderswift-production/',
            'https://www.google-analytics.com',
            'https://*.google-analytics.com',
            'https://www.googletagmanager.com',
            'https://*.googletagmanager.com',
            'https://googleads.g.doubleclick.net/',
            'https://www.google.com/ccm/collect',
            'https://www.google.com/rmkt/collect/',
            'https://www.google.co.uk/ads/ga-audiences',
            'https://www.google.com/pagead/',
            'https://www.google.co.uk/pagead/',
            'https://www.facebook.com',
            'https://maps.gstatic.com',
            'https://maps.googleapis.com'
        ],

        'style-src': [
            "'self'",
            "'unsafe-inline'",
            'https://s3.eu-west-2.amazonaws.com/' + process.env.REACT_APP_AWS_BUCKET + '/',
            'https://s3.eu-west-2.amazonaws.com/orderswift-production/',
            'https://fonts.googleapis.com'
        ],

        'font-src': [
            "'self'",
            'data:',
            'https://s3.eu-west-2.amazonaws.com/' + process.env.REACT_APP_AWS_BUCKET + '/',
            'https://s3.eu-west-2.amazonaws.com/orderswift-production/',
            'https://fonts.gstatic.com'
        ],

        'script-src': [
            "'self'",
            "'unsafe-eval'",
            "'unsafe-inline'",
            'https://js.stripe.com',
            'https://connect.facebook.net',
            'https://www.google-analytics.com',
            'https://www.googletagmanager.com',
            'https://googleads.g.doubleclick.net/',
            'https://maps.googleapis.com',
            'https://www.clarity.ms',
            'https://scripts.clarity.ms'
        ],

        'connect-src': [
            "'self'",
            process.env.REACT_APP_API_URL,
            'https://o4511387715829760.ingest.de.sentry.io',
            'https://www.google-analytics.com',
            'https://*.google-analytics.com',
            'https://region1.google-analytics.com',
            'https://analytics.google.com',
            'https://*.analytics.google.com',
            'https://region1.analytics.google.com',
            'https://www.googletagmanager.com',
            'https://*.googletagmanager.com',
            'https://www.google.com/rmkt/collect/',
            'https://www.google.com/ccm/collect',
            'https://www.google.co.uk/ads/ga-audiences',
            'https://maps.googleapis.com',
            'https://api.woosmap.com',
            'https://www.google.com/maps/conversion/debug/collect',
            'https://www.google.com/maps/conversion/collect',
            'https://l.clarity.ms/collect'
        ],

        'frame-src': [
            'https://js.stripe.com',
            'https://www.google.com',
            'https://maps.googleapis.com'
        ],

        'report-uri': [
        	'https://orderswift.report-uri.com/r/d/csp/enforce'
        ],

        'report-to': [
        	'default'
        ]
    };

    let str = '';

    Object.entries(csp).forEach(([key, value]) => {
        str += key + ' ' + value.join(' ') + '; ';
    });

    return str;
}
